import React, { FC, useEffect, useState } from 'react';
import { TWCText } from '@components';

import { Theme } from '@constants';
import { useContextReference } from '@hooks';

import { styles } from './styles';
import { SettingsMenuItemProps } from './types';

import { FocusableHighlight } from '../../focusable/FocusableHighlight/FocusableHighlight';

export const SettingsMenuItem: FC<SettingsMenuItemProps> = ({
  index,
  isActive,
  item,
  setActiveMenuItem,
  settingsMenuItemsLength,
  settingsMenuReferences,
}) => {
  const { accessibilityHint, accessibilityLabel, labelTestID, nextFocus, testID, title } = item;

  const [nextFocusRightState, setNextFocusRightState] = useState<number | null>(null);
  const reference = settingsMenuReferences[index];
  const nextFocusDown = settingsMenuReferences[index + 1]?.current || null;
  const nextFocusUp = settingsMenuReferences[index - 1]?.current || null;

  const nextFocusRight = useContextReference(nextFocus.right) || {
    current: null,
  };

  /**
   * Refs act quirky here, and don't seem to get recognized on first render after changing active item
   * Using state that updates on a focus change to store the ref forces a re-render and fixes this
   */
  useEffect(() => {
    setNextFocusRightState(nextFocusRight?.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, nextFocus]);

  return (
    <FocusableHighlight
      bottomHighlight
      accessibilityHint={accessibilityHint}
      accessibilityLabel={accessibilityLabel}
      activeOpacity={1}
      nativeID={testID}
      nextFocusDown={nextFocusDown}
      nextFocusRight={nextFocusRightState}
      nextFocusUp={nextFocusUp}
      ref={reference}
      style={[
        styles.settingsMenuItem,
        {
          marginTop: index === settingsMenuItemsLength - 1 ? Theme.px(90) : undefined,
        },
        title === 'Debug' ? styles.settingsDebugMenuItem : null,
      ]}
      testID={testID}
      underlayColor={Theme.transparent}
      onFocus={() => setActiveMenuItem(testID)}
    >
      <TWCText testID={labelTestID} variant={isActive ? 'regularText30' : 'regularText30LessTransparent'}>
        {title}
      </TWCText>
    </FocusableHighlight>
  );
};
